var StoreKey;
(function (StoreKey) {
    StoreKey["AUTH_TOKEN"] = "dfx.srv.authenticationToken";
    StoreKey["REDIRECT_URI"] = "dfx.srv.redirectUri";
    StoreKey["BALANCES"] = "dfx.srv.balances";
    StoreKey["LANGUAGE"] = "dfx.srv.language";
    StoreKey["ACTIVE_WALLET"] = "dfx.srv.activeWallet";
})(StoreKey || (StoreKey = {}));
export function useStore() {
    const { localStorage } = window;
    function set(key, value) {
        localStorage.setItem(key, value);
    }
    function get(key) {
        var _a;
        return (_a = localStorage.getItem(key)) !== null && _a !== void 0 ? _a : undefined;
    }
    function remove(key) {
        localStorage.removeItem(key);
    }
    return {
        redirectUri: {
            get: () => get(StoreKey.REDIRECT_URI),
            set: (value) => set(StoreKey.REDIRECT_URI, value),
            remove: () => remove(StoreKey.REDIRECT_URI),
        },
        balances: {
            get: () => get(StoreKey.BALANCES),
            set: (value) => set(StoreKey.BALANCES, value),
            remove: () => remove(StoreKey.BALANCES),
        },
        language: {
            get: () => get(StoreKey.LANGUAGE),
            set: (value) => set(StoreKey.LANGUAGE, value),
            remove: () => remove(StoreKey.LANGUAGE),
        },
        activeWallet: {
            get: () => get(StoreKey.ACTIVE_WALLET),
            set: (value) => set(StoreKey.ACTIVE_WALLET, value),
            remove: () => remove(StoreKey.ACTIVE_WALLET),
        },
    };
}
